import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ContextService } from './context.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class SearchService {

  constructor( 
    private apiService: ApiService,
    private contextService: ContextService,
   ) {}

  public query: string;
  public editeur: number;
  public niveau: number;
  public classe: number;
  public type: number;
  public discipline: number;
  body: any;

  getSearchResults(): Observable<Array<any>> {
    this.body = JSON.parse(sessionStorage.getItem('search_request_hachette_kne'));
    // console.log(this.body);
  	this.body.marche = this.contextService.getContext();
    if (this.body.editeur[0] === null || this.body.editeur[0] === 0) this.body.editeur = [];
    if (this.body.niveau[0] === null || this.body.niveau[0] === 0) this.body.niveau = [];
    if (this.body.classe[0] === null || this.body.classe[0] === 0) this.body.classe = [];
    if (this.body.typeArticle[0] === null || this.body.typeArticle[0] === 0) this.body.typeArticle = [];
    if (this.body.discipline[0] === null || this.body.discipline[0] === 0) this.body.discipline = [];
    if (this.body.page === null) this.body.page = 1;

   // console.log(this.body);

    return this.apiService.post('/recherche/article', this.body)
            .map(data => {
              // console.log(data.json().result);
              return data.json().result});
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/search.service.ts